/* ===============================
   cookie-consent.js (Pennello)
   big-site / simple / stable
   =============================== */
(function () {
  "use strict";

  const STORAGE_KEY = "pnl_cookie_consent_v2";
  const CONSENT_TTL_DAYS = 180;
  const CONSENT_TTL_MS = CONSENT_TTL_DAYS * 86400000;

  // ---- utils ----
  const $ = (s) => document.querySelector(s);
  const qs = new URLSearchParams(location.search);
  const now = () => Date.now();

  const read = () => {
    try { return JSON.parse(localStorage.getItem(STORAGE_KEY)); }
    catch { return null; }
  };

  const write = (v) => {
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify(v)); } catch {}
  };

  const clear = () => {
    try { localStorage.removeItem(STORAGE_KEY); } catch {}
  };

  // ---- show / hide ----
  const show = (el) => {
    if (!el) return;
    el.hidden = false;
    requestAnimationFrame(() => el.classList.add("is-visible"));
  };

  const hide = (el) => {
    if (!el) return;
    el.classList.remove("is-visible");
    setTimeout(() => { el.hidden = true; }, 350);
  };

  // ---- clarity (optional, fail-quiet) ----
  const clarity = (method, payload) => {
    try {
      typeof window.clarity === "function" &&
        window.clarity(method, payload);
    } catch {}
  };

  function boot() {
    const banner = $("#pnl-cookie-banner");
    const btnAccept = $("#pnl-accept");
    const btnReject = $("#pnl-reject");

    if (!banner || !btnAccept || !btnReject) return;

    // ---- consent ----
    const setConsent = (granted) => {
      const value = granted ? "granted" : "denied";
      const data = {
        ad_storage: value,
        analytics_storage: value,
        ts: now()
      };

      write(data);
      clarity("consentv2", data);
      hide(banner);
    };

    // ---- init ----
    (function init() {
      if (qs.get("cookie_reset") === "1") clear();

      const saved = read();
      const valid = saved && (saved.analytics_storage === "granted" || saved.analytics_storage === "denied");
      const expired = valid && saved.ts && (now() - saved.ts > CONSENT_TTL_MS);

      if (!valid || expired) {
        expired && clear();
        show(banner);
      } else {
        clarity("consentv2", {
          ad_storage: saved.ad_storage,
          analytics_storage: saved.analytics_storage
        });
        hide(banner);
      }

      // debug (optional)
      window.PennelloCookies = {
        reset: () => { clear(); show(banner); }
      };
    })();

    // ---- events ----
    btnAccept.addEventListener("click", () => setConsent(true));
    btnReject.addEventListener("click", () => setConsent(false));
  }

  document.readyState === "loading"
    ? document.addEventListener("DOMContentLoaded", boot, { once: true })
    : boot();

})();
